import React, { useCallback } from 'react';
import { RATING_TOOLTIP_MESSAGES } from 'config';
import { StarRatingProps, TooltipProps, Box, BoxProps } from '@qga/roo-ui/components';

interface RatingTooltipProps {
  isEnabled?: boolean;
  ratingType?: StarRatingProps['ratingType'];
}

export default function useRatingTooltip({ ratingType, isEnabled = true }: RatingTooltipProps) {
  const onClick = useCallback((event: React.SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();
  }, []);

  const ratingMessage = ratingType ? RATING_TOOLTIP_MESSAGES[ratingType] : null;
  if (!ratingMessage || !isEnabled) return undefined;

  const children = (
    <Box width={['100%', '100%', '335px']} height="auto" pl={1} pr={4}>
      {ratingMessage}
    </Box>
  );

  const tooltip: TooltipProps = {
    fixedCloseButton: true,
    whiteSpace: 'wrap',
    textAlign: 'left',
    pointerPosition: '8%',
    colorMode: 'dark',
    children,
    onClick,
  };

  const tooltipWrapper: BoxProps = {
    px: [4, 0],
  };

  return {
    tooltip,
    tooltipWrapper,
  };
}
